//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    location: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState([ 'order', 'options' ])
  },
  data() {
    return {
      showTime: false
    }
  },
  methods: {
    async startOrder() {
      console.log('start order')
      this.$store.commit('setLocation', this.location)
      this.$store.commit('setMenu', null)
      this.$store.commit('setOrder', null)
      this.$store.commit('setTimePicker', true)
      // this.showTime = true
      // await this.$api.getMenu()
      // let order = null
      // if(this.order) {
      //   order = await this.$api.transferOrder()
      //   if(!order) {
      //     order = await this.$api.setHandoff('pickup')
      //   }
      //   if(order && order.totals.tip > 0) {
      //     await this.$api.addTip(0)
      //   }
      // } else {
      //   order = await this.$api.createOrder()
      // }
      // if(order) {
      //   // if(this.orderType == 'delivery') {
      //   //   let order2 = await this.$api.setAddress(this.$store.state.customer.delivery)
      //   //   if(order2) {
      //   //     this.$router.push('/order/')
      //   //   }
      //   // } else {
      //     await this.$api.setHandoff('pickup')
      //     this.$router.push('/order/')
      //   // }
      // }
    },
    async selectTime(time) {
      if(time == 'close') {
        this.showTime = false
      } else {
        let handoff_time = time
        if(time == 'asap') {
          if(this.location.calendar.default.length > 0) {
            let earliest = moment(this.location.calendar.default[0].open, 'YYYYMMDD HH:mm')
            let latest = moment(this.location.calendar.default[0].close, 'YYYYMMDD HH:mm')
            if(moment() < earliest) {
              handoff_time = this.location.calendar.default[0].open
            } else if(moment() > latest) {
              handoff_time = this.location.calendar.default[1].open
            } else {
              handoff_time = null
            }
          } else {
            handoff_time = null
          }
        }
        await this.$api.getMenu(false, true, handoff_time)
        let order = await this.$api.createOrder(handoff_time)
        if(order) {
          this.$router.push('/order/')
        }
      }
    },
    setStore() {
      this.$store.commit('setLocation', this.location)
      this.$store.commit('setOrder', null)
      this.$router.push('/menu/')
    },
    getHours(i) {
      // return 'TBD'
      if(this.location.hours && (this.location.hours.length < 1 || this.location.hours[i].open == this.location.hours[i].close)) {
        return 'Open 24 hours'
      } else if(this.location.hours) {
        let string = `${moment(this.location.hours[i].open, 'H:mm').format('h:mma')}-${moment(this.location.hours[i].close, 'H:mm').format('h:mma')}`
        return string.replace(/\:00/g, '')
      }
    },
    phone(s) {
      let cleaned = ('' + s).replace(/\D/g, '')
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    }
  }
}
